import { IMeeting } from 'types';

export const filterMeetingNotEnded = (meeting: IMeeting) => !meeting.minutesEndedAt;
